import { render } from "./LbrxPrivacyPolicy.vue?vue&type=template&id=73c7c325&scoped=true"
import script from "./LbrxPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LbrxPrivacyPolicy.vue?vue&type=script&lang=js"

import "./LbrxPrivacyPolicy.vue?vue&type=style&index=0&id=73c7c325&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c7c325"]])

export default __exports__